import { Component, Injector, OnInit } from '@angular/core';
import { _HttpClient } from "@delon/theme";

@Component({
  selector: 'app-bank-charges-modal',
  templateUrl: './bank-charges.component.html',
  styleUrls: ['./bank-charges.component.less'],
  standalone: false
})
export class BankChargesComponent implements OnInit {
  bankChargesAccountId: string | null = '';
  glAccs: any;
  loading = false;

  constructor(
    protected injector: Injector,
    private http: _HttpClient
  ) {}

  ngOnInit(): void {
    this.loadOption();
  }

  loadOption() {
    this.loading = true;
    this.http.get('api/accountCodes/leaf').subscribe({
      next: (res: any) => {
        let specialAccs4 = ['', 'ADA', 'BAC', 'BOAC', 'CAC', 'MAC', 'PT', 'ST'];
        this.glAccs = res.filter(
          (o: any) =>
            o.isActive &&
            !o.hasChildren &&
            (specialAccs4.includes(o.specialCode) || !o.specialCode)
        );
        this.glAccs.sort((a: any, b: any) => a.code.localeCompare(b.code));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
